export default "__VITE_ASSET__CIExgHb1__"